import React from 'react'

export default function Errors({errors}) {

    const normalized = (() => {
        if (!errors) return {};
        if (Array.isArray(errors)) return errors.length ? { general: errors } : {};
        if (typeof errors === 'object') return errors;
        return { general: [String(errors)] };
    })();

    const hasErrors = Object.keys(normalized).length > 0;

    return (
        hasErrors && (
            <div className="mb-6 bg-red-50 border border-red-200 text-sm text-red-800 rounded-lg p-4 dark:bg-red-800/10 dark:border-red-900 dark:text-red-500" role="alert">
                <div className="flex">
                    <div className="flex-shrink-0">
                        <svg
                            className="flex-shrink-0 h-4 w-4 mt-0.5"
                            xmlns="http://www.w3.org/2000/svg"
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        >
                            <circle cx="12" cy="12" r="10" />
                            <path d="m15 9-6 6" />
                            <path d="m9 9 6 6" />
                        </svg>
                    </div>
                    <div className="ms-4">
                        <h3 className="text-sm font-semibold">Sorry you cant submit this data before validit this fields</h3>
                        <div className="mt-2 text-sm text-red-700 dark:text-red-400">
                            {Object.keys(normalized).map((fieldName) => (
                                <ul key={fieldName} className="list-disc space-y-1 ps-5">
                                    {(Array.isArray(normalized[fieldName]) ? normalized[fieldName] : [String(normalized[fieldName])]).map((errorMessage, index) => (
                                        <li key={index}>{errorMessage}</li>
                                    ))}
                                </ul>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        )
    );
}
